import {memo, useMemo} from 'react';

import styled from 'styled-components';
import {AdvancedMarker} from '@vis.gl/react-google-maps';

import {Coordinate, MarkerTypeEnum} from '~/shared/components/Maps/types';
import {SupportedQueryParamsType} from '~/shared/router/supportedQueryParams';

import {serializeCoordinate} from './utils';
import Marker from './Marker';

const RoadMarker = styled.div<{color?: string}>`
  width: 10px;
  height: 10px;
  background-color: ${({theme, color}) => color || theme.colors.error};
`;

const Markers = ({
  businessLocation,
  onBusinessMarkerClick,
  userLocation,
  onUserMarkerClick,
  courierLocation,
  dotsOfLastRoute,
  centerLocation,
  debug,
}: {
  businessLocation?: Coordinate | null;
  onBusinessMarkerClick?: () => void;
  userLocation?: Coordinate | null;
  onUserMarkerClick?: () => void;
  courierLocation?: Coordinate | null;
  dotsOfLastRoute?: Coordinate[];
  centerLocation?: Coordinate | null;
  debug?: SupportedQueryParamsType['debug'];
}) => {
  const restaurantMarker = useMemo(() => {
    return (
      businessLocation && (
        <AdvancedMarker onClick={onBusinessMarkerClick} position={serializeCoordinate(businessLocation)}>
          <Marker type={MarkerTypeEnum.RESTAURANT} />
        </AdvancedMarker>
      )
    );
  }, [businessLocation, onBusinessMarkerClick]);

  const customerMarker = useMemo(() => {
    return userLocation && (
      <AdvancedMarker onClick={onUserMarkerClick} position={serializeCoordinate(userLocation)}>
        <Marker type={MarkerTypeEnum.CUSTOMER} />
      </AdvancedMarker>
    );
  }, [userLocation, onUserMarkerClick]);

  return (
    <>
      {restaurantMarker}
      {customerMarker}
      {courierLocation && (
        <AdvancedMarker position={serializeCoordinate(courierLocation)}>
          <Marker type={MarkerTypeEnum.COURIER} />
        </AdvancedMarker>
      )}
      {!!dotsOfLastRoute && dotsOfLastRoute.length && dotsOfLastRoute.map((coordinate: any, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <AdvancedMarker position={serializeCoordinate(coordinate)} key={`${index}_${JSON.stringify(coordinate)}`}>
          <RoadMarker>{index + 1}</RoadMarker>
        </AdvancedMarker>
      ))}
      {debug && centerLocation && (
        <AdvancedMarker position={serializeCoordinate(centerLocation)}>
          <RoadMarker color="lightgreen">Center</RoadMarker>
        </AdvancedMarker>
      )}
      {debug && userLocation && (
        <AdvancedMarker position={serializeCoordinate(userLocation)}>
          <RoadMarker color="orange">User</RoadMarker>
        </AdvancedMarker>
      )}
      {debug && businessLocation && (
        <AdvancedMarker position={serializeCoordinate(businessLocation)}>
          <RoadMarker color="lightblue">Business</RoadMarker>
        </AdvancedMarker>
      )}
    </>
  );
};

export default memo(Markers);
